// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/info/index.css
// module id = 22
// module chunks = 1 2 3 4 5 6